<template>
  <div class="auto-play-video" ref="videoWrapper">
    <video
      ref="videoElement"
      :src="src"
      :style="{ height }"
      :poster="poster"
      muted
      playsinline
      preload="auto"
      :autoplay="autoplay"
      :loop="loop"
      :controls="areControlsVisible"
    ></video>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'

@Component
export default class AutoPlayVideo extends Vue {
  @Prop({ required: true }) src!: string
  @Prop({ default: true }) autoplay!: boolean
  @Prop({ default: true }) loop!: boolean
  @Prop({ default: false }) controls!: boolean
  @Prop({ default: '' }) poster!: string
  @Prop({ default: '500px' }) height!: string

  areControlsVisible = false

  @Ref('videoElement') readonly videoElement!: HTMLVideoElement
  @Ref('videoWrapper') readonly videoWrapper!: HTMLElement

  mounted() {
    const video = this.videoElement
    const wrapper = this.videoWrapper

    if (!video || !wrapper) {      
      return
    }
    

    const observer = new IntersectionObserver(
      ([entry]) => {
        const isVisible = entry.isIntersecting
        
        if (isVisible) {
          
          if (this.autoplay) {
            video.loop = this.loop

            if (video.readyState < 3) {
              video.load()
            }

            const tryPlay = () => {
              if (video.paused) {
                video.play()
                  .then(() => {
                    console.log('▶️ Vídeo tocando')
                    if (this.controls) {
                      this.areControlsVisible = true
                    }
                  })
                  .catch(err => console.warn('⚠️ Erro ao dar play:', err))
              }
            }

            if (video.readyState >= 3) {
              tryPlay()
            } else {
              video.addEventListener('canplay', tryPlay, { once: true })
            }
          }
        } else {          
          video.pause()
          console.log('⏸️ Vídeo pausado')
        }
      },
      {
        threshold: 0.01
      }
    )
    observer.observe(wrapper)
  }
}
</script>

<style scoped>
.auto-play-video {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;  
}
.auto-play-video video {
  width: 1032px;
  height: 500px;
  object-fit: cover;  
}

@media (min-width: 1175px) {
  .auto-play-video video {     
    width: 100%;    
  }
}
</style>
